import React from 'react';
import useIsMobileView from "../../hooks/useIsMobileView";
import { Main, MainContent } from '@prosolve/common-components-ui'
import EventsList from '../EventsList/EventsList';

export default () => {
  const isMobileView = useIsMobileView();

  const filters = {};
  
  return (
    <Main 
      $isMobileView={isMobileView} 
      $backgroundColor={'#ffffff'}
      style={{ 
        padding: '5px', 
        minHeight: 'calc(100vh - 50px)' 
      }}
    >
      <MainContent $isMobileView={isMobileView} style={{ maxWidth: '1250px' }}>
        <div style={{ display: 'flex' }}>
          <div style={{ paddingTop: '40px', borderRight: '1px solid #C2C9D1'}}>
            Left Filters Here
          </div>
          <div style={{ flex: 1 }}>
            <EventsList filters={filters} />
          </div>
        </div>
      </MainContent>
    </Main>
  )
}
